import withRole from '.';
import { ROLES } from './type';

export const withAdminRole = withRole([ROLES.ADMIN]);
export const withManagerRole = withRole([ROLES.MANAGER]);
export const withAnalystRole = withRole([ROLES.ANALYST]);
export const withDeveloperRole = withRole([ROLES.DEVELOPER]);
